<template>
  
<div class="auth-container">
  
  <div class="banner-container" style="background: url('../../../static/img/banner.png') center/cover no-repeat"></div>
  
  <div class="login-container">
    <div class="login-row row justify-content-center align-items-center">
      <div class="col-xl-10 login-box">
        <div class="text-center">
          <h2 class="fadeInUp animation-delay1" style="font-weight:bold">
              <img src="../../../static/img/logo.png">
            </h2>
        </div>

        <router-view></router-view>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {}
</script>

<style lang="sass">
  // Need to import the necessary files funciotns/variables/mixins and the grid
  // @import "../../assets/styles/custom"
  // @import "~bootstrap/scss/bootstrap-reboot"

  html, body
    height: 100%;
    background-color: #fff;
  
  .auth-container 
    width: 100%;
    height: 100%;
    
  .banner-container 
    display: inline-block;
    width: 70%;
    height: 100%;
    
    img 
      width: 100%;
      height: 100%;
    
      
  .login-container
    width: 30%;
    float: right;
    display: inline-block
    min-width: 330px;
    height: 100%;
    overflow: hidden;
    background-color: #fff;

    .login-row
      height: 100%;
      // @include make-row()

      .login-box
        // padding: 30px;
        border-radius: 7px;
        
        img 
          max-width: 220px;
              
        a
          color: white;
</style>


// WEBPACK FOOTER //
// src/components/containers/ContainerFull.vue